<div class="modal-header" style="padding: 15px !important; border-bottom: 1px solid #e5e5e5;">
    <h4 class="modal-title wrap-text-in">Update Job Location</h4>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-xs-12">
            <div class="main-box">
                <div class="main-box-body">
                    <manage-entity-location entityType="job" [entityId]="modalData.jobId" [showSave]="true"
                        [isRequired]="true" [location]="modalData.location" (saveCallback)="saveCallback($event)"
                        (cancelCallback)="closeModal()" (clearLocationCallback)="clearLocation()">
                    </manage-entity-location>
                </div>
            </div>
        </div>
    </div>
</div>
